import React, { useEffect, useState } from 'react';

import { Cancel, CheckCircle } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';

const CoachingExperiene = ({
  data,
  setData,
  coachingExperiene,
  setDisableSave,
  disableSave,
}) => {
  const [verify, setVerify] = useState({});
  const [coachingExperieneData, setCoachingExperieneData] = useState([]);

  const getListOfRoles = (list) => {
    const data = [];
    if (list?.length > 0) {
      list.forEach((role) => {
        data.push(role.name);
      });
    }
    return data;
  };

  useEffect(() => {
    if (Object.keys(verify).length > 0) {
      if (coachingExperiene?.length === Object.keys(verify).length) {
        setDisableSave({ ...disableSave, coachingExperiene: false });
      } else {
        setDisableSave({ ...disableSave, coachingExperiene: true });
      }
    }
  }, [verify]);

  useEffect(() => {
    if (coachingExperieneData.length > 0) {
      setData({
        ...data,
        coachingExperience: [...coachingExperieneData],
      });
    }
  }, [coachingExperieneData]);

  return (
    <>
      <div className=' shadow-xl rounded-lg col-span-3'>
        <div className='bg-gray-200 py-2 px-4 text-[#134F5C] text-base font-semibold'>
          Coaching Experience
        </div>
        {/* </div> */}

        <div className='flex flex-col space-y-10 justify-center w-full py-6'>
          {coachingExperiene?.length > 0 &&
            coachingExperiene.map((exp, index) => {
              return (
                <div className='flex items-center gap-14  px-4' key={index}>
                  <span className=' flex items-center w-3/4'>
                    <span className='ml-2'>
                      <div className=' flex flex-col space-y-1'>
                        <div className=' opacity-80 text-base'>
                          {exp.domain}
                        </div>
                        <div className='opacity-60 text-sm'>
                          {getListOfRoles(exp?.coachRoleName).join(', ')}
                        </div>
                        <div className=' opacity-50'>
                          {exp.companyName} ({exp.years} year)
                        </div>
                      </div>
                    </span>
                  </span>
                  <span className='w-1/4 flex items-center justify-between'>
                    <span className=' opacity-60 text-sm'>
                      Coaching Exp {index + 1}
                    </span>
                    <span>
                      <IconButton
                        onClick={() => {
                          setVerify({ ...verify, [index]: 'yes' });
                          setCoachingExperieneData([
                            ...coachingExperieneData,
                            exp,
                          ]);
                        }}
                        className='focus:outline-none'
                      >
                        <CheckCircle
                          htmlColor={
                            verify[index] === 'yes' ? '#76CE65' : 'inherit'
                          }
                        />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          setVerify({ ...verify, [index]: 'no' });
                          coachingExperieneData.splice(index, 1);
                          setCoachingExperieneData([...coachingExperieneData]);
                        }}
                        className='focus:outline-none'
                      >
                        <Cancel
                          htmlColor={
                            verify[index] === 'no' ? '#CC0000' : 'inherit'
                          }
                        />
                      </IconButton>
                    </span>
                  </span>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default CoachingExperiene;
